module.exports = __webpack_public_path__ + "01_medium_gold.d95a2f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_medium_gold.png
// module id = O8VV
// module chunks = 0